/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import {
	getIcon,
	retrieveFromStorage,
	saveToStorage,
} from "../../Components/Functions";
import { ACCESS_PAGE } from "../../Constants/main";
import { routers } from "../../Constants/routers";
import { login } from "../../Redux/User/actions";
import Api from "../../Server/Api";
import AuthLayout from "./AuthLayout";

const api = new Api();

export const LoginForm = (props) => {
	const remember_me_data = retrieveFromStorage("REMEMBER_ME") || {};
	const username = React.useRef(null);
	const password = React.useRef(null);
	const [loading, setLoading] = React.useState(false);
	const [message, setMessage] = React.useState();

	const [data, setData] = React.useState({ ...remember_me_data });

	const _login = async () => {
		if (!data?.username || !data?.password) {
			notyf.open({
				type: "error",
				message: "Please enter both username and password to login.",
			});
			return;
		}
		setLoading(true);
		const res = await api.post({ endpoint: "/token/", data });
		if (res?.access) {
			props.login(res);
			if (props?.callback) props.callback();
			else {
				const accessPage = retrieveFromStorage(ACCESS_PAGE);
				if (accessPage) {
					saveToStorage({ name: ACCESS_PAGE, value: null });
					window.location = accessPage;
				} else {
					window.location = routers.dashboard.base;
				}
			}
		} else {
			let time = 5;
			setMessage(res?.detail || res?.message || "Unknown error message.");
			const interval = setInterval(() => {
				if (time < 1) {
					clearInterval(interval);
					setMessage();
				}
				time--;
			}, 1000);
		}
		setLoading(false);
	};

	React.useEffect(() => {
		setData({
			username: username?.current?.value || data?.username,
			password: password?.current?.value || data?.password,
		});
	}, []);

	const updateRememberMe = (remember_me = false) => {
		saveToStorage({
			name: "REMEMBER_ME",
			value: remember_me ? { ...data, remember_me: true } : {},
		});
	};

	return (
		<div className="form-card">
			<form>
				<div id="signin-form" className="login-form">
					{message && (
						<div className={`message is-${"danger"}`}>
							<div
								class="message-body"
								dangerouslySetInnerHTML={{ __html: message }}
							/>
						</div>
					)}

					{/* Input */}
					<div className="field">
						<div className="control has-icon">
							<input
								ref={username}
								className="input"
								type="text"
								placeholder="Username"
								defaultValue={data?.username}
								onInput={(e) => setData({ ...data, username: e.target.value })}
							/>
							<span
								className="form-icon"
								dangerouslySetInnerHTML={{ __html: getIcon("user") }}
							/>
						</div>
					</div>
					{/* Input */}
					<div className="field">
						<div className="control has-icon">
							<input
								ref={password}
								className="input"
								type="password"
								placeholder="Password"
								defaultValue={data?.password}
								onInput={(e) => setData({ ...data, password: e.target.value })}
							/>
							<span
								className="form-icon"
								dangerouslySetInnerHTML={{ __html: getIcon("lock") }}
							/>
						</div>
					</div>
					<div className="setting-item">
						<label className="form-switch is-primary">
							<input
								type="checkbox"
								defaultChecked={remember_me_data?.remember_me}
								onChange={(e) => updateRememberMe(e.target.checked)}
								className="is-switch"
								id="busy-mode-toggle"
							/>
							<i />
						</label>
						<div className="setting-meta">
							<span>Remember Me</span>
						</div>
					</div>
					{/* Submit */}
					<div className="control login">
						<button
							type="button"
							className={`button h-button is-primary is-bold is-fullwidth is-raised ${
								loading ? "is-loading" : ""
							}`}
							onClick={() => _login()}
						>
							Sign In
						</button>
					</div>
				</div>
			</form>
		</div>
	);
};

const Login = (props) => {
	return (
		<AuthLayout>
			<LoginForm {...props} />
			<div className="forgot-link has-text-centered">
				<a href={routers.auth.password_reset}>Forgot Password?</a>
			</div>
		</AuthLayout>
	);
};

const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return { login: (e) => dispatch(login(e)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
